import React from 'react'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import PrimaryButton from 'components/generic/PrimaryButton'
import { Spinner } from './style'

const LoadingIndicatorButton = ({ children, isLoading, disabled, ...rest }) => {
  return (
    <PrimaryButton disabled={disabled || isLoading} {...rest}>
      {children}
      {isLoading && <Spinner icon={faSpinner} spin />}
    </PrimaryButton>
  )
}

export default LoadingIndicatorButton
